//GeneratorFlag:[NoChange]
import City from './city';
import Province from './province';

export default {City, Province}
export{City, Province}